import CardInfo from "./cardInfo";
import CertificatesInfo from "./certificatesInfo";
import classes from "./about.module.css";
import ProjectsCollection from "./projectCollection";
import SkillsSection from "./SkillsSection";

const AboutMain = () => {
  return (
    <>
      <div className={classes.mainContainerAbout}>

        <div className={classes.aboutMe}>
          <p>
           <span className={classes.intro}> Hi, I'm Vivek Sharma</span> — a software developer and curious learner who
            thrives on exploring new ideas and building solutions that blend
            technology with creativity. I specialize in Node.js (Express.js) for
            backend development and have skills in React.js, Next.js, and AWS.
            Along with building projects, I share my knowledge and learnings on
            LinkedIn to connect with the tech community. I enjoy taking concepts
            from syntax to solution, whether it's creating intuitive web
            experiences, optimizing backend systems, or experimenting with
            blockchain, and I've also gained experience in website design,
            domain management, content creation, and marketing through diverse
            projects and internships.
          </p>

          <p>
            My approach is detail-oriented, methodical, and practical — I don't
            just aim to get things done, I aim to get them done well. At the
            same time, I value authenticity: I'm a person of my word, confident
            in my path, and not concerned with what's said behind my back.
          </p>

          <p>
            When I'm not coding or building strategies, I enjoy exploring anime,
            books, food, travel, and creative design — things that fuel both my
            curiosity and imagination.
          </p>

          <p>
            In short, I'm not just a programmer; I'm a problem-solver, creator,
            and learner for life.
          </p>

          <p className={classes.Funfact}>
            Fun fact: I once spent more time perfecting the design of my code
            editor theme than watching an entire anime season — because
            aesthetics matter in creativity too!
          </p>
        </div>

        <p className={classes.SectionHeading}>
          <span>Education & Experience</span>
        </p>
        <div className={classes.presentCurrent}>
          <CardInfo />
        </div>

        <p className={classes.SectionHeading}>
          <span>Projects</span>
        </p>
        <div className={classes.projectFlex}>
          <ProjectsCollection />
        </div>

        <p className={classes.SectionHeading}>
          <span>Certificates & Achievements</span>
        </p>
        <div className={classes.certificatesFlex}>
          <CertificatesInfo />
        </div>

        <p className={classes.SectionHeading}>
          <span>Skills | Technologies</span>
        </p>
        <div className={classes.SkillsSection}>
          <SkillsSection />
        </div>
      </div>
    </>
  );
};

export default AboutMain;
